interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

const ContactSupportIcon = ({ width = 16, height = 16, color = 'black' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_722_2430)'>
        <path
          d='M2.42553 6C2.01353 6 1.69353 5.628 1.7662 5.22267C2.00553 3.88867 2.6702 2.64867 3.66953 1.712C4.95953 0.502001 6.6442 -0.101332 8.4202 0.0140012C11.7675 0.230001 14.3822 3.144 14.3329 6.62533C14.3062 8.504 12.7402 10.0007 10.8609 10.0007H8.9062C8.6662 10.2313 8.3422 10.3747 7.98353 10.3747C7.24686 10.3747 6.6502 9.778 6.6502 9.04134C6.6502 8.30467 7.24686 7.708 7.98353 7.708C8.58886 7.708 9.0942 8.114 9.25686 8.66734H10.8609C12.0182 8.66734 12.9869 7.74534 12.9995 6.58867C13.0302 3.82467 10.9695 1.516 8.3342 1.34533C6.93486 1.25867 5.6002 1.73067 4.58086 2.686C3.77486 3.44133 3.25553 4.40867 3.07353 5.47133C3.0202 5.782 2.7402 6.00133 2.42553 6.00133V6ZM8.0002 11.3333C5.53686 11.3333 3.40553 12.8613 2.69686 15.1347C2.63353 15.3373 2.6702 15.558 2.7962 15.7287C2.9222 15.8993 3.12153 16 3.33353 16H12.6669C12.8789 16 13.0782 15.8993 13.2042 15.7287C13.3302 15.558 13.3669 15.3373 13.3035 15.1347C12.5949 12.8613 10.4635 11.3333 8.0002 11.3333ZM9.9562 7.33333H11.5255C11.6155 7.01533 11.6669 6.68067 11.6669 6.33333C11.6669 4.308 10.0255 2.66667 8.0002 2.66667C5.97486 2.66667 4.33353 4.308 4.33353 6.33333C4.33353 7.32733 4.73086 8.22733 5.37286 8.888C5.45353 7.51067 6.58553 6.41533 7.98353 6.41533C8.77753 6.41533 9.47753 6.776 9.95686 7.33333H9.9562Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_722_2430'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ContactSupportIcon;
